export const HOME_SECTION_IDS = [
  "hero",
  "siteDescription",
  "blogs",
  "news",
  "events",
  "jobs",
  "deals",
  "featuredListings",
  "freeListings",
  "businessesByTag",
  "featuredSlider",
  "homepageOptin",
];

export const DEFAULT_HOME_SECTION_ORDER = [...HOME_SECTION_IDS];

/** Original hardcoded order — used when no saved order exists. */
export const LEGACY_HOME_SECTION_ORDER = [
  "hero",
  "siteDescription",
  "featuredListings",
  "freeListings",
  "businessesByTag",
  "featuredSlider",
  "blogs",
  "events",
  "news",
  "jobs",
  "deals",
  "homepageOptin",
];

export const HOME_SECTION_LABELS = {
  hero: "Hero section",
  siteDescription: "Site description",
  blogs: "Blog posts",
  news: "News",
  events: "Events",
  jobs: "Jobs",
  deals: "Deals",
  featuredListings: "Premium listings showcase",
  freeListings: "Free listings",
  businessesByTag: "Businesses by tag",
  featuredSlider: "Featured listings slider",
  homepageOptin: "Homepage optin form",
};

export function resolveHomeSectionOrder(savedOrder) {
  if (!Array.isArray(savedOrder) || savedOrder.length === 0) {
    return LEGACY_HOME_SECTION_ORDER;
  }

  const validIds = new Set(HOME_SECTION_IDS);
  const seen = new Set();
  const resolved = [];

  for (const id of savedOrder) {
    if (validIds.has(id) && !seen.has(id)) {
      resolved.push(id);
      seen.add(id);
    }
  }

  for (const id of HOME_SECTION_IDS) {
    if (!seen.has(id)) {
      resolved.push(id);
    }
  }

  return resolved;
}
